export default "/images/ic-signup.svg?b8b8fcd4d8a3b8099bd3056b8c83e923";